export function AuthBrandPanel() {
  return (
    <aside className="auth-brand">
      <a
        className="auth-brand__logo"
        href="/login"
        aria-label="Autochek Talentchek home"
      >
        <img src="/autochekhrms.png" alt="Talentcheck" style={{ height: '70px', width: 'auto' }} />
      </a>
      <div className="auth-brand__story">
        <span className="auth-brand__eyebrow">
          <span /> Workforce Intelligence Platform
        </span>
        <h1>
          Your people,
          <br />
          <em>one platform.</em>
        </h1>
        <p>
          HR operations, leave, performance, policies and talent — unified for
          growing teams across the organization.
        </p>
        <div className="auth-brand__features" aria-label="Your workspace">
          <span>People & culture</span>
          <span>Time to recharge</span>
          <span>Room to grow</span>
        </div>
        <div className="auth-brand__statement">
          <div>
            A better day at work.
            <small>Connected people. Shared possibilities.</small>
          </div>
        </div>
      </div>
      <footer>
        © {new Date().getFullYear()} Autochek Africa · Talentchek HR
      </footer>
    </aside>
  );
}
